import { type RootState } from "../globaltypes/redux";

export const isPackReadOnlySelector = (state: RootState) => {
  return !state.packs.packDetailsReducer.pack.isDraft;
};
